import { AssetInfo as OldAssetInfo } from "@models/tradable/split/asset_info";

export interface TradableInfo {
	readonly id: string;
	readonly description: string;
	readonly info: string;
	readonly infoIntegration: string;
	readonly extraInfo: string;
}

export class TradableInfoAdapter {
	public adapt(info: OldAssetInfo): TradableInfo {
		return {
			id: info.getId(),
			description: info.getDescription(),
			info: info.getInfo(),
			extraInfo: info.getExtraInfo(),
			infoIntegration: info.getInfoIntegration()
		};
	}
}
